<template>
  <footer class="footer mt-auto py-3">
    <div class="container">


      <div class="row privacy">
        <p>Puedes encontrar nuestros avisos de privacidad <a href="https://saludnl.gob.mx/drupal/aviso-de-privacidad" target="_blank">aquí</a></p>
      </div>


      <div class="row text-center">
        <p>Siguenos en nuestras redes oficiales</p>
        <div style="display: inline-block">
          <a href="https://www.facebook.com/SecretariaSaludNL/" target="_blank"
            ><span class="mdi mdi-facebook"></span
          ></a>
          <a href="https://twitter.com/NlSalud" target="_blank"
            ><span class="mdi mdi-twitter"></span
          ></a>
        </div>
      </div>

      <div class="row">
        <p class="text-center">
          {{ copyright }}
        </p>
      </div>

      <div class="row">
        <img src="@/assets/gob/logos/logo_gobierno.png" class="footer-img" />
      </div>
    </div>
  </footer>
</template>


<script>
export default {
  name: "Footer",
  props: {
    copyright: String,
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  /*height: 200px;*/
  background-color: #263238;
  color: white;
  margin-top: 36px;
  font-size: 14pt;
}

.footer img {
  width: 100px;
  margin-left: auto;
  margin-right: auto;
}

.mdi{
  color: white;
  font-size: 2.3rem;
  padding: 8px;
}

.privacy{
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: .9rem;
}
</style>